// @mui
import Stack from "@mui/material/Stack";
import { styled, alpha } from "@mui/material/styles";
// config
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import { Container } from "@mui/material";
import { StyledTab } from "components/common/StyledTabs";
import { REQUESTS_FILTERS } from "constants/APPLICATIONS";
import { getCurrentMonth } from "components/common/MonthPicker";

const StyledNavbar = styled(Stack)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  padding: "8px 12px",
}));
const StyledTabs = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  width: "100%",
  backgroundColor:
    theme.palette.mode === "dark"
      ? alpha(theme.palette.background.paper, 0.5)
      : alpha(theme.palette.background.paper, 0.8),
  padding: "5px",
  borderRadius: 16,
  overflowX: "scroll",
  border: `1px solid ${
    theme.palette.mode === "dark"
      ? alpha(theme.palette.common.white, 0.06)
      : alpha(theme.palette.common.black, 0.04)
  }`,
  backdropFilter: "blur(12px)",
  WebkitBackdropFilter: "blur(12px)",
  "&::-webkit-scrollbar": { display: "none" },
  "& .MuiTab-root": {
    borderRadius: 12,
    minHeight: 36,
    padding: "6px 16px",
    fontSize: "0.8rem",
    fontWeight: 500,
    color: theme.palette.text.secondary,
    transition: theme.transitions.create(
      ["background-color", "color", "font-weight"],
      {
        duration: theme.transitions.duration.shortest,
      }
    ),
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.04),
    },
  },
  "& .MuiTab-root[class*='isactive-true']": {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
}));

export const DashboardHorizontalNavbar = () => {
  const currentMonth = getCurrentMonth();

  const [query, setQuery] = useQueryParams({
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 50),
    formIdentifier: withDefault(StringParam, ""),
    fromDate: withDefault(StringParam, currentMonth.startOfMonth),
    toDate: withDefault(StringParam, currentMonth.endOfMonth),
  });

  function onIdentifierFilter(newIdentifier: string | undefined) {
    setQuery((q) => ({ ...q, formIdentifier: newIdentifier }));
  }
  return (
    <Container
      sx={{
        bgcolor: (theme) => theme.palette.background.default,
        height: "fit-content",
        p: 0,
      }}
    >
      <StyledNavbar>
        <StyledTabs>
          <StyledTab
            label={"همه"}
            value={""}
            $isactive={query.formIdentifier === ""}
            onClick={() => onIdentifierFilter(undefined)}
          />
          {Object.entries(REQUESTS_FILTERS).map((filter, index) => (
            <StyledTab
              key={index}
              label={filter[1]}
              id={`full-width-tab-${index}`}
              aria-controls={`full-width-tabpanel-${index}`}
              value={filter[0]}
              $isactive={filter[0] === query.formIdentifier}
              onClick={() => onIdentifierFilter(filter[0])}
            />
          ))}
        </StyledTabs>
      </StyledNavbar>
    </Container>
  );
};
